import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ChannelAppResource from './ChannelAppResource';
import ChannelMemberAppResource from './ChannelMemberAppResource';
import FileAppResource from './FileAppResource';
import MessageChannelMemberReadAppResource from './MessageChannelMemberReadAppResource';
import MessageMentionAppResource from './MessageMentionAppResource';
import OrganizationMemberAppResource from './OrganizationMemberAppResource';
import UserAppResource from './UserAppResource';
import WorkspaceOrganizationMemberAppResource from './WorkspaceOrganizationMemberAppResource';

class MessageAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'message';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'messages';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'channelUuid',
            'versionOfMessageUuid',
            'senderUserUuid',
            'senderChannelMemberUuid',
            'senderOrganizationMemberUuid',
            'senderWorkspaceOrganizationMemberUuid',
            'content',
            'messageType',
            'isFinal',
            'senderUser',
            'senderChannelMember',
            'senderOrganizationMember',
            'senderWorkspaceOrganizationMember',
            'channel',
            'versionOfMessage',
            'previousMessageVersion',
            'attachments',
            'channelMemberReads',
            'mentions',
            'channels',
            'ref',
            'senderWorkspaceOrganizationMember',
            'attachmentsMeta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            senderUser: UserAppResource,
            senderChannelMember: ChannelMemberAppResource,
            senderOrganizationMember: OrganizationMemberAppResource,
            senderWorkspaceOrganizationMember: WorkspaceOrganizationMemberAppResource,
            channel: ChannelAppResource,
            versionOfMessage: MessageAppResource,
            previousMessageVersion: MessageAppResource,
            attachments: FileAppResource,
            channelMemberReads: MessageChannelMemberReadAppResource,
            mentions: MessageMentionAppResource,
            channels: ChannelAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            senderUser: 'sender_user_uuid',
            senderChannelMember: 'sender_channel_member_uuid',
            senderOrganizationMember: 'sender_organization_member_uuid',
            senderWorkspaceOrganizationMember: 'sender_workspace_organization_member_uuid',
            channel: 'channel_uuid',
            versionOfMessage: 'version_of_message_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            channelUuid: {
                type: 'string',
                presence: true,
            },
            channel: {
                type: 'string',
            },
            senderWorkspaceOrganizationMemberUuid: {
                type: 'string',
                presence: true,
            },
            senderWorkspaceOrganizationMember: {
                type: 'string',
            },
            versionOfMessageUuid: {
                type: 'string',
            },
            senderUserUuid: {
                type: 'string',
            },
            senderChannelMemberUuid: {
                type: 'string',
            },
            senderOrganizationMemberUuid: {
                type: 'string',
            },
            content: {
                type: 'string',
            },
            messageType: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
                inclusion: [
                    'announcement',
                    'regularMessage',
                ],
            },
            isFinal: {
                type: 'boolean',
            },
            ref: {
                type: 'string',
                presence: true,
            },
            attachments: {
                array: {
                    items: {
                        type: 'string',
                    },
                },
            },
            attachmentsMeta: {
                array: {
                    items: {
                        array: {
                            items: {
                                type: 'string',
                            },
                        },
                    },
                },
            },
        };
    }

}

export default MessageAppResource;
